import React, { useState, useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
      const docEl = document.documentElement;
      const scrollTop = window.scrollY;
      const scrollHeight = docEl.scrollHeight - docEl.clientHeight;
      setScrollProgress(scrollHeight > 0 ? (scrollTop / scrollHeight) * 100 : 0);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { label: 'Home',           path: '/' },
    { label: 'About Us',       path: '/about' },
    { label: 'Services',       path: '/services' },
    { label: 'Infrastructure', path: '/infrastructure' },
    { label: 'Solutions',      path: '/solutions' },
    { label: 'Clients',        path: '/clients' },
    { label: 'Quality',        path: '/quality' },
    { label: 'Contact',        path: '/contact' },
  ];

  return (
    <nav className={`navbar ${scrolled ? 'navbar-scrolled' : ''}`}>
      <div
        className="scroll-progress-bar"
        style={{ width: `${scrollProgress}%` }}
        aria-hidden="true"
      />
      <div className="container navbar-inner">
        {/* Logo */}
        <div className="navbar-logo" aria-label="C2P Engineering Solutions">
          <img src="/images/logo-mark.png" alt="C2P Engineering Solutions" className="navbar-logo-img" />
        </div>

        {/* Desktop Nav */}
        <ul className="navbar-links">
          {navItems.map((item) => (
            <li key={item.label} className="nav-item">
              <NavLink
                to={item.path}
                end={item.path === '/'}
                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
              >
                {item.label}
              </NavLink>
            </li>
          ))}
        </ul>

        <Link to="/contact" className="navbar-cta">Let's Connect</Link>

        {/* Hamburger */}
        <button
          className={`hamburger ${menuOpen ? 'open' : ''}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span /><span /><span />
        </button>
      </div>

      {/* Mobile Menu */}
      <div className={`mobile-menu ${menuOpen ? 'open' : ''}`}>
        {navItems.map((item) => (
          <div key={item.label} className="mobile-nav-item">
            <NavLink
              to={item.path}
              end={item.path === '/'}
              className="mobile-nav-link"
              onClick={() => setMenuOpen(false)}
            >
              {item.label}
            </NavLink>
          </div>
        ))}
        <Link to="/contact" className="navbar-cta mobile-cta" onClick={() => setMenuOpen(false)}>
          Let's Connect
        </Link>
      </div>
    </nav>
  );
};

export default Navbar;
